(function () {
    'use strict';

    var timer;
    var header = $(".js-nav");
    var navItems = header.find(".js-nav-item");
    var moreMenu = header.find('.js-more-menu');
    var waitTime = 100;
    var navOpen = false;

    function open(_navItem) {
        close(navItems.not(_navItem));
        _navItem.addClass("nav__item--open");

        if (_navItem.hasClass('nav__item--more')) {
            moreMenu.removeClass('more-menu--no-animate');
            header.addClass('nav--more-opened');
        }

        if (_navItem.hasClass("nav__item--current")) {
            navItems.filter(".nav__item--current").addClass("nav__item--non-hover");
        }
    }

    function close(_navItem) {
        if (navOpen) {
            _navItem.addClass("nav__item--no-animate");
        } else {
            _navItem.removeClass("nav__item--no-animate");
        }

        if (_navItem.hasClass('nav__item--more')) {
            header.removeClass('nav--more-opened');

            if (navOpen) {
                moreMenu.addClass('more-menu--no-animate');
            }
        }

        _navItem.removeClass("nav__item--open");
        navItems.filter(".nav__item--current").removeClass("nav__item--non-hover");
    }

    function wait(callback, _navItem) {
        clearTimeout(timer);
        timer = setTimeout(function() {
            callback(_navItem);
        }, waitTime);
    }

    navItems.on("mouseenter", function() {
        navOpen = true;
        wait(open, $(this));
    });

    header.on("mouseleave", function() {
        navOpen = false;
        wait(close, navItems);
    });

    moreMenu.hover(
        function () {
            navOpen = true;
            clearTimeout(timer);
        },
        function () {
            navOpen = false;
            wait(close, navItems);
        }
    );

    header.on('click', '.nav__item--more', function (e) {
        e.preventDefault();
        return false;
    });

    $('.social-list__item').socialOverlayToggle();
})();
